import { Helmet } from 'react-helmet';
import SETitle from './../components/seTitle';
import SEButton from './../components/seButton';

const Page404 = () => <>
    <Helmet>
        <title>Page Not Found | Sparkling Email Dashboard</title>
    </Helmet>
    <div className="flex flex-col items-center justify-center text-center py-20">
        <SETitle title="Page Not Found" noUnderline />
        <p className="text-slate-600">Sorry, the page you are looking for does not exist.</p>
        <div className="flex flex-inline justify-center gap-4 my-8">
            <SEButton variant='outline' onClick={() => window.location.href = '/'}>
                Back to Sparkling Email Dashboard
            </SEButton>
        </div>
    </div>
</>


export default Page404;